import * as React from 'react';
import {
  ArrayInput,
  BooleanInput,
  FormDataConsumer,
  ReferenceArrayInput,
  SaveButton,
  SelectArrayInput,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  Toolbar,
  useNotify,
  useRefresh,
  required,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { CourseCityDateInputs } from '../../CourseCityDate/Inputs';

const CalendarSaveButton = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { reset } = useFormContext();

  const onSuccess = (response) => {
    notify(`CourseCityDates saved!`, { type: 'success' });
    reset();
    refresh();
  };

  return (
    <SaveButton
      {...props}
      type={'button'}
      mutationOptions={{
        onSuccess: onSuccess,
      }}
    />
  );
};

const CalendarToolbar = () => (
  <Toolbar>
    <CalendarSaveButton />
  </Toolbar>
);

export const CourseCalendarForm = ({ course }) => {
  return (
    <SimpleForm
      toolbar={<CalendarToolbar />}
      sanitizeEmptyValues={true}
      defaultValues={{ course: course.id }}
    >
      <ReferenceArrayInput
        source={'cities'}
        reference={'cities'}
        filter={{ company: course.company }}
        name={'Cities'}
      >
        <SelectArrayInput
          source={'cities'}
          reference={'cities'}
          optionText={'view'}
          id="cities"
          validate={required()}
        />
      </ReferenceArrayInput>
      <BooleanInput
        label="Termin auf Anfrage"
        source="onDemand"
        id="onDemand"
      />
      <SelectInput
        required
        source="formType"
        validate={required()}
        id="formType"
        choices={[
          { id: 1, name: 'Groß' },
          { id: 2, name: 'Klein' },
          { id: 3, name: 'Online Bewerbung' },
        ]}
      />
      <ArrayInput source={'dates'}>
        <SimpleFormIterator>
          <FormDataConsumer>
            {({ getSource, scopedFormData }) => (
              <CourseCityDateInputs
                getSource={getSource}
                scopedFormData={scopedFormData}
                company={course.company}
                companySupplier={course.supplier}
                initializeSupplier
              />
            )}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  );
};
